
import Vue from "vue";
import notifications from "@/lib/notifications";
import Component from "vue-class-component";
import { RoleListResource } from "../../models/api/system/roles";
import { AgentUserResource, SaveAgentUserRequest } from "../../models/api/system/agentUsers";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import { Watch, Ref, Prop } from "vue-property-decorator";
import { formatDateWithTime } from "../../utils";
import { formatPhoneNumber } from "@/utils";

const systemModule = getModule(SystemModule);

@Component
export default class AgentUserEdit extends Vue {
  @Prop()
  id: string;

  @Prop({default: true})
  showSaveButton: boolean;



  getHeight() : string {
    return this.showSaveButton ? "500px" : "300px"
  }

  onlySelected: boolean = false;
  searchName: string = "";
  loading: boolean = false;
  loadingPage: boolean = false;
  roles: RoleListResource[] = [];
  userDetail: AgentUserResource = {
    id: null,
    externalId: null,
    firstName: null,
    lastName: null,
    email: null,
    roleId: null,
    roleName: null,
    agentId: null,
    agentName: null,
    facilityString: null,
    phone: null,
    isActive: null,
    lastAccess: null,
    password: null,
    confirmPassword: null,
    hasAccessToAllFacilities: null,
    hasAccessToAllAgentFacilities: null,
    isSuperUser: false,
    isUserManager: false
  };
  agentFacilities: any = [];
  
  @Prop({default: false})
  wantCallbacks: boolean;

  @Prop()
  agentId: number | null;
  
  getAgentId() {
    return this.agentId == null ? this.userDetail.agentId : this.agentId;
  }

  @Ref() readonly validator!: any;

  getIdentityId() : string {
    return this.id ?? this.$route.params.externalId
  }

  toggleOnlySelected() {
    this.onlySelected = !this.onlySelected;
  }
  async created() {
    this.loadingPage = true;
    if (this.getIdentityId()) {
      this.userDetail = await systemModule.getAgentUserDetail( {externalId: this.getIdentityId(), agentId: this.getAgentId()});

      if(this.userDetail.facilityString != null) {
        await systemModule.loadAgentFacilitiesByAgentId(this.agentId);
        const facilityList = systemModule.agentFacilities;
        this.agentFacilities = facilityList.filter(item => item.facilityCode).map(x => ({ label: `${this.getActiveText(x.isActive)} ${this.getFacilityNameText(x.name)} (${this.getCompanyNameText(x.companyName)}) - ${x.state}`, value: x.facilityCode, isActive: x.isActive, isSelected: true, state: x.state }));
        this.agentFacilities.forEach(x => x.isSelected = this.userDetail.facilityString.indexOf(x.value)>-1)
      }
    }
    this.roles = await systemModule.getRoles(this.getAgentId());
    this.loadingPage = false;
  }

  filterFacilities(Facilities) {
    let regex = new RegExp( this.searchName, "i");

    return Facilities
      .filter( item => (!this.searchName || 
        regex.test( item.value ) || 
        regex.test( item.label ) || 
        regex.test( item.state ) || 
        regex.test( item.roleName )) && (this.onlySelected==false || item.isSelected == true));
  }
  
  formatDateWithTime(val){
    return formatDateWithTime(val);
  }

  toggleFacility(facility) {
    facility.isSelected = !facility.isSelected;
  }

  getFacilityNameText(facilityName) {
    return facilityName || 'Facility name not available';
  }

  getCompanyNameText(companyName) {
    return companyName || 'Company name not available';
  }

  getActiveText(isActive) {
    return isActive ? '' : 'Inactive ';
  }

  isNew() {
    return this.getIdentityId()=="create";
  }

  validateFormForSave() {
    this.validator.setErrors({"role": ["This field is required"]});

    this.validator.validate().then(isValid => {
      if(isValid)
        this.save();
    });
  }

  formatPhone(value) {
        const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$set(this.userDetail, 'phone', !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
    }

  formattedPhoneNumber(phoneNumber) {
    return phoneNumber ? formatPhoneNumber(phoneNumber) : '';
  }

  async save() {
    let request = new SaveAgentUserRequest();
    request.externalId = this.userDetail.externalId;
    request.firstName = this.userDetail.firstName;
    request.lastName = this.userDetail.lastName;
    request.id = this.userDetail.id;
    request.phone = this.formattedPhoneNumber(this.userDetail.phone);
    request.email = this.userDetail.email,
    request.roleId = this.userDetail.roleId;
    request.agentId = this.getAgentId();
    request.hasAccessToAllAgentFacilities = this.userDetail.hasAccessToAllAgentFacilities;
    request.hasAccessToAllFacilities = this.userDetail.hasAccessToAllFacilities;
    request.facilities = this.agentFacilities.filter(x => x.isSelected == true).map(y => y.value)
    request.isActive = this.userDetail.isActive;
    request.password=this.userDetail.password;
    request.confirmPassword=this.userDetail.confirmPassword;
    request.isSuperUser = this.userDetail.isSuperUser;
    request.isUserManager = this.userDetail.isUserManager;

    this.loading = true;

    await systemModule
      .saveAgentUser(request)
      .then(response => {
        notifications.success("User saved", "User changes saved");

        if(this.wantCallbacks) {
          this.$emit("UserUpdated");
        } else {
          if (this.isNew()) this.$router.push(`/admin/users/${response.externalId}`);
        }
      })
      .catch(ex => {
        notifications.error("Save User", "Failed to save user", ex);
      })
      .finally(() => {
        this.loading = false;
      });
  
}
}
